/**
 * StreamingBlock — Web renderer for STREAMING content blocks.
 *
 * Currently renders a "coming soon" placeholder. The streaming block config
 * controls display options (layout, chat, viewer count); actual stream data
 * comes from hub.streamingSettings which is rendered by HubStreamingSection
 * directly in HubPage.tsx — not through the content block system.
 *
 * The `layout` value is applied as a CSS class suffix only — actual layout
 * rendering is delegated to HubStreamingSection when wired up.
 */

import "./StreamingBlock.scss";

interface StreamingBlockConfig {
    showChat?: boolean;
    showViewerCount?: boolean;
    /** Controls CSS layout class suffix. Actual visual differentiation is in HubStreamingSection. */
    layout?: "theater" | "compact" | "featured";
    maxStreams?: number;
}

interface StreamingBlockProps {
    config?: StreamingBlockConfig;
    sectionTitle?: string;
}

export const StreamingBlock = ({ config, sectionTitle }: StreamingBlockProps) => {
    const layout = config?.layout || "featured";

    return (
        <div className="streaming-block">
            {sectionTitle && <h2 className="section-title">{sectionTitle}</h2>}
            <div className={`streaming-block__container streaming-block__container--${layout}`}>
                <div className="streaming-block__coming-soon">
                    <p className="streaming-block__text">
                        Live streaming section — configure streams in Streaming Settings.
                    </p>
                </div>
            </div>
        </div>
    );
};
